import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export async function GetPubSubToken(org:any): Promise<any> {
    const config: AxiosRequestConfig = {
      method: "GET",
      params: {
        clientId: "100",
        salesOrg:org
      },
      url: `${BASE_URL}/api/webpubsubtoken`
    };
  
    return await AXIOS_INSTANCE(config)
      .then((v) => v.data)
      .catch((err) => console.error(err));
  }
  

  export async function DisconnectPubSub(org:any): Promise<any> {
    let id=localStorage.getItem('connectionId')||''
    const config: AxiosRequestConfig = {
      method: "POST",
      params: {
        clientId: "100",
        salesOrg:org,
     
      },
      data:{id:id},
      url: `${BASE_URL}/api/webpubsubtoken/closeSocket`
    };
    
    return await AXIOS_INSTANCE(config)
      .then((v) => v.data)
      .catch((err) => console.error(err));
  }
  

  export async function sendTosocket (obj:any,org:any): Promise<any> {
    const config: AxiosRequestConfig = {
      method: "POST",
      params: {
        clientId: "100",
        salesOrg:org,
      },
      data:obj,
      url: `${BASE_URL}/api/webpubsubtoken/emitMessage`
    };
    
    return await AXIOS_INSTANCE(config)
      .then((v) => v.data)
      .catch((err) => console.error(err));
  }
  

  